var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
import { inject, singleton } from "tsyringe";
import { GlobalConfig } from "../config";
import { makeImmutable } from "../core";
import { StorageManagerFactory } from "../storage";
import { ApartmentInfo } from "../ordering";
let ApartmentInfoFactory = class ApartmentInfoFactory {
    constructor(globalConfig, storageManagerFactory) {
        this.storageManagerFactory = storageManagerFactory;
        this.country = globalConfig.country;
        makeImmutable(this);
    }
    create() {
        const apartmentInfoStorageManager = this.storageManagerFactory.forApartmentInfo();
        return ApartmentInfo.fromStorageData({
            storageData: apartmentInfoStorageManager.restore(),
            country: this.country,
        });
    }
};
ApartmentInfoFactory = __decorate([
    singleton(),
    __param(0, inject(GlobalConfig)),
    __metadata("design:paramtypes", [typeof (_a = typeof GlobalConfig !== "undefined" && GlobalConfig) === "function" ? _a : Object, typeof (_b = typeof StorageManagerFactory !== "undefined" && StorageManagerFactory) === "function" ? _b : Object])
], ApartmentInfoFactory);
export { ApartmentInfoFactory };
